import './index.scss';
import Tooltip from '../Tootlip';
import { useEffect, useState } from 'react';
import {
  useCreditInUse,
  useSetCreditInUse,
  useCredits,
  useFetchCredits,
} from '../../../store/credits/creditsHooks';
import { useTranslation } from 'react-i18next';
import { getTheRightCredit } from '../../../utility/services/credits-calculate';

type PropsTypes = {
  creditTypes: CreditTypesEnum;
  price: number;
  discount?: number;
  disabledCreditUser?: boolean;
  isPurchasable?: boolean;
  isWaitingListMode?: boolean;
};

export enum CreditTypesEnum {
  COMPANY = 'COMPANY',
  USER = 'USER',
}

const BookingCheckout = (props: PropsTypes) => {
  const { t } = useTranslation();

  const credits = useCredits();

  const creditInUse = useCreditInUse();
  const setCreditInUse = useSetCreditInUse();

  const fetchCredits = useFetchCredits();

  const [netPrice, setNetPrice] = useState(0);

  useEffect(() => {
    if (props.disabledCreditUser) {
      return;
    }

    fetchCredits(props.creditTypes).finally();
  }, []);

  useEffect(() => {
    const newNetPrice = props.discount
      ? (props.price * (100 - props.discount)) / 100
      : props.price;

    setNetPrice(newNetPrice);
    if (props.disabledCreditUser) {
      setCreditInUse(undefined!, undefined!, newNetPrice);
    } else {
      const response = getTheRightCredit(credits, newNetPrice);

      setCreditInUse(
        response.credits,
        response.creditInUse,
        response.balanceToPay
      );
    }
  }, [props.price, credits, props.disabledCreditUser]);

  const allRemainingCredits = () => {
    let count = 0;
    credits.forEach((item) => {
      if (+item.amount > +item.usage) {
        count = count + +item.amount - +item.usage;
      }
    });

    return count;
  };

  const fullPrice = !props.price || props.price === 0 ? '0' : `₪${props.price}`;
  const costAfterDiscount =
    // eslint-disable-next-line no-mixed-operators
    props.price - props.price * (props?.discount ? props?.discount / 100 : 0);

  if (!props.isPurchasable && !props.isWaitingListMode) {
    return <div></div>;
  }

  return (
    <div className="booking-checkout">
      <div className="booking-total">
        <span>{t('PRICE')}</span>
        <span>{fullPrice}</span>
      </div>
      {Boolean(props.discount) && (
        <div className="booking-total">
          <span>{t('DISCOUNT')}</span>
          <span>{props.discount}%</span>
        </div>
      )}
      {Boolean(props.discount) && (
        <div className="booking-total">
          <span>{t('AFTER_DISCOUNT')}</span>
          <span>{costAfterDiscount}</span>
        </div>
      )}
      <div className="credit-use">
        <span>{t('CREDIT_USE')}</span>
        {!creditInUse?.creditsAmount ? (
          <span>₪0</span>
        ) : (
          <span>-₪{+`${creditInUse?.creditsAmount}`}</span>
        )}
      </div>
      {/*{credits.length && !props.isWaitingListMood ? (*/}
      {/*  <div className="credit-balance">*/}
      {/*    <span>{t('NEW_CREDIT_BALANCE')}</span>*/}
      {/*    {!creditInUse?.creditsAmount ? (*/}
      {/*      <span>₪0</span>*/}
      {/*    ) : (*/}
      {/*      <span>*/}
      {/*        ₪{allRemainingCredits() - +`${creditInUse?.creditsAmount}`}*/}
      {/*      </span>*/}
      {/*    )}*/}
      {/*  </div>*/}
      {/*) : (*/}
      {/*  <div></div>*/}
      {/*)}*/}
      <div className="checkout-line" />
      <div className="total-cost">
        <span className="total-cost-tooltip">
          <Tooltip
            title={t('UPDATE_ORDER_TOOLTIP_TITLE')}
            text={t('CREDIT_USE_TOOLTIP_TEXT')}
            text2={t('UPDATE_ORDER_TOOLTIP_TEXT')}
          />
        </span>
        <span className="total-cost-title">{t('TOTAL_COST')}</span>
        <span>
          ₪
          {Math.round(
            (creditInUse ? creditInUse?.cashAmount || 0 : netPrice) * 100
          ) / 100}
        </span>
      </div>
    </div>
  );
};

export default BookingCheckout;
